var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { GetReportVersion } from "../../services/ai-report";
import { useCallback, useEffect, useState } from 'react';
export var useAiReportVersion = function (token) {
    var _a = __read(useState(-1), 2), version = _a[0], setVersion = _a[1];
    var reloadReportVersion = useCallback(function () {
        GetReportVersion(token)
            .then(function (res) {
            var _a = res, code = _a.code, data = _a.data;
            if (code === 0) {
                var _b = data.isNewVersion, isNewVersion = _b === void 0 ? false : _b;
                setVersion(isNewVersion ? 2 : 1);
            }
        })
            .catch(console.log);
    }, [token]);
    useEffect(function () {
        reloadReportVersion();
    }, [reloadReportVersion]);
    return { version: version, reloadReportVersion: reloadReportVersion };
};
export default useAiReportVersion;
